import request from '@/utils/request'

export default {
    getAccountBalanceHistoryByDate: async({ dispatch, commit }, data) => {
        if (data.table) {
            commit('SET_LOAD', true)
        }

        await request({ method: 'get', url: 'balance-history/date', params: { format: data.format }})
            .then(res => {
                if (data.chart && data.table) {
                    commit('SET_BALANCE_HISTORY_TABLE', res.data)
                    commit('SET_BALANCE_HISTORY', res.data)
                } else if (data.table) {
                    commit('SET_BALANCE_HISTORY_TABLE', res.data)
                } else {
                    commit('SET_BALANCE_HISTORY', res.data)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    },
    getReferralsHistoryByDate: async({ dispatch, commit }, data) => {
        if (data.table) {
            commit('SET_LOAD', true)
        }

        await request({ method: 'get', url: 'referrals/date', params: { format: data.format }})
            .then(res => {
                if (data.chart && data.table) {
                    commit('SET_REFERRAL_HISTORY_TABLE', res.data.referralsHistory)
                    commit('SET_REFERRAL_HISTORY', res.data.referralsHistory)
                } else if (data.table) {
                    commit('SET_REFERRAL_HISTORY_TABLE', res.data.referralsHistory)
                } else {
                    commit('SET_REFERRAL_HISTORY', res.data.referralsHistory)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    },
    getOrdersHistoryByDate: async({ dispatch, commit }, data) => {
        if (data.table) {
            commit('SET_LOAD', true)
        }

        await request({ method: 'get', url: '/orders-history/date', params: { format: data.format }})
            .then(res => {
                if (data.chart && data.table) {
                    commit('SET_ORDERS_HISTORY_TABLE', res.data)
                    commit('SET_ORDERS_HISTORY', res.data)
                } else if (data.table) {
                    commit('SET_ORDERS_HISTORY_TABLE', res.data)
                } else {
                    commit('SET_ORDERS_HISTORY', res.data)
                }
            }).finally(() => {
                commit('SET_LOAD', false)
            })
    }
}
